import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      nav("/login");
    } catch (er) {
      setErr(formatApiError(er));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--cream)] px-6">
      <div className="w-full max-w-md card-warm p-8">
        <h1 className="font-display text-3xl mb-2">Choose a new password</h1>
        <p className="text-sm text-[color:var(--stone)] mb-6">Reset links expire in 1 hour.</p>
        {!token ? (
          <div className="text-sm text-[color:var(--red)]">Missing reset token.</div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input data-testid="reset-password-input" type="password" required minLength={6} placeholder="New password" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full px-4 py-3 rounded-full border-2 border-[color:var(--border)] outline-none focus:border-[color:var(--ink)] bg-white" />
            {err && <div className="text-sm text-[color:var(--red)]">{err}</div>}
            <button data-testid="reset-submit-btn" disabled={busy} className="w-full btn-pill btn-primary">{busy ? "Saving…" : "Set new password"}</button>
          </form>
        )}
        <div className="mt-4 text-sm text-center">
          <Link to="/login" className="text-[color:var(--stone)] hover:text-[color:var(--ink)]">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
